<template>
  <nav class="sidebar" :class="sidebarTheme">
    <ul class="nav mt-2 mb-4 d-flex">
      <li
        v-if="myOrganizations.length > 1"
        class="nav-item nav-organization-selector"
      >
        <div class="mb-3">
          <b-form-select
            v-model="selectedOrganization"
            :options="organizationsOptions"
            :disabled="disableSelect"
            size="sm"
            @change="switchOrganization"
          ></b-form-select>
        </div>
      </li>
      <li v-if="showBranch" class="nav-item nav-organization-selector">
        <div class="mb-3">
          <b-form-select
            v-model="selectedBranch"
            :options="branchOptions"
            :disabled="disableSelect"
            size="sm"
            @change="switchBranch"
          ></b-form-select>
        </div>
      </li>

      <!-- <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'DashboardHome' }">
            <i class="menu-icons"></i>
            <span class="menu-title">主介面</span>
          </router-link>
        </li> -->

      <template v-for="i in sidebarMap">
        <li
          v-if="
            i.items.length > 0 &&
            (i.checkPermissionAny
              ? checkPermissionAny(i.checkPermissionAny)
              : i.checkPermission
              ? checkPermission(i.checkPermission)
              : true)
          "
          class="nav-item"
          :style="{ order: sidebarOrder(i.key) || i.order }"
          :key="i.key"
        >
          <a class="nav-link" v-b-toggle="`${i.key}`">
            <icon :src="i.icon" />
            <!-- <i class="menu-icons"></i> -->
            <span class="menu-title">{{ i.text }}</span>
            <i class="menu-arrow"></i>
          </a>
          <b-collapse :id="i.key" :visible="subMenuVisible(i)">
            <ul class="nav flex-column sub-menu">
              <template v-for="(j, jdx) in i.items">
                <li
                  v-if="
                    j.checkPermissionAny
                      ? checkPermissionAny(j.checkPermissionAny)
                      : j.checkPermission
                      ? checkPermission(j.checkPermission)
                      : true
                  "
                  class="nav-item"
                  :key="jdx"
                >
                  <router-link
                    class="nav-link"
                    :class="subMenuActive(j) && 'active'"
                    :to="j.to"
                    >{{ j.text }}</router-link
                  >
                </li>
              </template>
            </ul>
          </b-collapse>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from 'vuex'
import PermissionChecker from '@/utils/PermissionChecker'
import { displayText } from '@/utils/dashboardUtils'
import * as consts from '@/consts'
import Vue from "vue";
import bookingApi from "@/apis/booking";
import preorderApi from "@/apis/preorder";
import orgVariableConfig from "@/utils/orgVariableConfig";

const requireImage = (path) =>
  require(`@/assets/images/sidebar/${path}`);

const PREORDER_COUNT = 20;
const BOOKING_COUNT = 10;

const icon = Vue.component("icon", {
  props: ["src"],
  render(h) {
    return h("img", {
      class: "menu-icons",
      style: {
        maskImage: this.getIconMask(this.$props.src),
        webkitMaskImage: this.getIconMask(this.$props.src),
      },
    });
  },
  methods: {
    getIcon(path) {
      try {
        return requireImage(path);
      } catch {
        return "";
      }
    },
    getIconMask(src) {
      return `url(${this.getIcon(src)})`;
    },
  },
});


export default {
  name: 'app-sidebar',
  props: ['themeConfig'],
  components: {
    icon,
  },
  data() {
    return {
      disableSelect: false,
      selectedBranch: null,
      selectedOrganization: null,
      consts: consts,
      bookingPresets: [],
      preorderSettings: [],
      sidebarDebugCache: null,
    }
  },
  mounted() {
    this.init()

    // 設定 Dashboard 的 Title
    if (this.themeConfig.og_title !== null || this.themeConfig.og_title !== undefined) {
      document.title = this.themeConfig.og_title;
    } else {
      document.title = "";
    }

    // 設定 Dashboard 的 favicon
    if (this.themeConfig.og_favicon_url !== null || this.themeConfig.og_favicon_url !== undefined) {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = this.themeConfig.og_favicon_url;
    }
  },
  computed: {
    ...mapState('general', {
      myBranches: state => state.myBranches,
      currentBranch: state => state.currentBranch,
      myOrganizations: state => state.myOrganizations,
      organization: state => state.organization,
      sidebarTheme: (state) => state.sidebarTheme,
      dashboardModule: (state) => state.dashboardModule
    }),
    ...mapGetters('general', ['role', 'permissions', 'branchOptions']),
    organizationsOptions() {
      return this.myOrganizations.map(organization => {
        return {
          value: organization.id,
          text: organization.name
        }
      })
    },
    showBranch() {
      return this.branchOptions.length > 0 && this.checkPermission([consts.MY_SIDEBAR_BRANCH])
    },
    // showOrgSetting() {
    //   return this.checkPermission([consts.ORGANIZATION_VARIABLE]) ||
    //     this.checkPermission([consts.ROLE_LIST_VIEW]) ||
    //     this.checkPermission([consts.MODULE_LIST_VIEW]) ||
    //     this.checkPermission([consts.KEYWORD_LIST_VIEW]) ||
    //     this.checkPermission([consts.SQL_RUNNER_LIST_VIEW]) ||
    //     this.checkPermission([consts.MERCHANT_LIST_VIEW]) ||
    //     this.checkPermission([consts.LOGS_LIST_VIEW]) ||
    //     this.checkPermission([consts.TOKEN_LIST_VIEW])
    // },
    sidebarMap() {
      return [
        {
          key: "sidebar-my-console",
          text: "我的主控台",
          order: 100,
          logic: 'OR',
          icon: 'gauge-solid.svg',
          checkPermissionAny: [
            consts.MY_OVERVIEW,
            consts.CHATROOM_LIST_CHAT_VIEW,
            consts.MY_CUSTOMER_LIST,
            consts.MY_REDEEM_CODE_LIST_VIEW,
            consts.MY_DEPT_CUSTOMER_LIST,
            consts.MY_EXPORT,
            consts.MY_MANUAL_TASK,
            consts.MY_SCHEDULED_TASK,
          ],
          items: [
            { to: { name: 'Overview' }, text: '系統總覽', checkPermission: [consts.MY_OVERVIEW] },
            { to: { name: 'ChatroomIndex' }, text: '聊天室總覽', checkPermission: [consts.CHATROOM_LIST_CHAT_VIEW] },
            { to: { name: 'MyConsoleStaffCustomerList' }, text: '我的客戶', checkPermission: [consts.MY_CUSTOMER_LIST] },
            { to: { name: 'MyConsoleRedeemCodeBundleList' }, text: '我的優惠券', checkPermission: [consts.MY_REDEEM_CODE_LIST_VIEW] },
            { to: { name: 'MyConsoleBranchStaffCustomerList' }, text: '部門客戶', checkPermission: [consts.MY_DEPT_CUSTOMER_LIST] },
            { to: { name: 'MyConsoleDownloadFileList' }, text: '資料匯出', checkPermission: [consts.MY_EXPORT] },
            { to: { name: 'MyConsoleManualTaskList' }, text: '手動任務狀態', checkPermission: [consts.MY_MANUAL_TASK] },
            { to: { name: 'MyConsoleScheduledTaskList' }, text: '系統執行紀錄', checkPermission: [consts.MY_SCHEDULED_TASK] },
          ]
        },
        {
          key: "sidebar-line-oa",
          text: "LINE 應用中心",
          icon: 'line-brands-solid.svg',
          order: 150,
          checkPermissionAny: [
            consts.OA_MESSAGE_VIEW,
            consts.OA_PUSH_VIEW,
            consts.LINE_MENU_LIST_VIEW
          ],
          items: [
            { to: { name: 'OAChatroomIndex' }, text: 'LINE 聊天', checkPermission: [consts.OA_MESSAGE_VIEW] },
            { to: { name: 'PushMessage' }, text: '群發訊息', checkPermission: [consts.OA_PUSH_VIEW] },
            { to: { name: 'PushMessageTemplate' }, text: '訊息範本', checkPermission: [consts.OA_PUSH_VIEW] },
            { to: { name: 'RichMenu' }, text: '圖文選單', checkPermission: [consts.LINE_MENU_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-customer",
          text: "會員管理中心",
          icon: 'users-gear-solid.svg',
          order: 200,
          checkPermissionAny: [
            consts.CUSTOMER_LIST_VIEW,
            consts.CUSTOMER_LEVEL_LIST,
            consts.CUSTOMER_LEVEL_RULE_LIST,
            consts.AUDIENCE_LIST_VIEW,
            consts.TAG_LIST_VIEW,
            consts.CUSTOMER_MERGE,
          ],
          items: [
            { to: { name: 'CustomerList' }, text: '會員管理', checkPermission: [consts.CUSTOMER_LIST_VIEW] },
            { to: { name: 'CustomerLevelsList' }, text: '會員等級管理', checkPermission: [consts.CUSTOMER_LEVEL_LIST] },
            { to: { name: 'CustomerLevelRuleList' }, text: '會員等級條件', checkPermission: [consts.CUSTOMER_LEVEL_RULE_LIST] },
            { to: { name: 'AudienceList' }, text: '受眾管理', checkPermission: [consts.AUDIENCE_LIST_VIEW] },
            { to: { name: 'TagList' }, text: '標籤管理', checkPermission: [consts.TAG_LIST_VIEW] },
            { to: { name: 'CustomerMerging' }, text: '會員合併', checkPermission: [consts.CUSTOMER_MERGE] },
          ]
        },
        {
          key: "sidebar-core_groupbuyings",
          text: "團購中心",
          icon: 'cart-shopping-solid.svg',
          order: 250,
          checkPermissionAny: [
            consts.CORE_GROUPBUYING_LIST_VIEW,
            consts.CORE_GROUPBUYING_CREATE,
            consts.CORE_GROUPBUYING_MODIFY,
            consts.CORE_GROUPBUYING_PRODUCT_LIST,
          ],
          items: [
            { to: { name: 'CoreGroupbuyingsListV2' }, text: '團購管理', checkPermission: [consts.CORE_GROUPBUYING_LIST_VIEW] },
            { to: { name: 'CoreGroupbuyingsList' }, text: '團購草稿', checkPermissionAny: [consts.CORE_GROUPBUYING_CREATE, consts.CORE_GROUPBUYING_MODIFY] },
            { to: { name: 'CoreGroupbuyingsProductList' }, text: '團購商品管理', checkPermissionAny: [consts.CORE_GROUPBUYING_PRODUCT_LIST] }
          ]
        },
        {
          key: "sidebar-partner",
          text: this.displayText('partner.partner_area', '合作夥伴專區'),
          icon: 'building-user-solid.svg',
          order: 300,
          checkPermissionAny: [consts.PARTNER_WORKER_LIST_VIEW, consts.PARTNER_LIST_VIEW, consts.PARTNER_STAFF_LIST_VIEW],
          items: [{ to: { name: 'PartnerList' }, text: this.displayText('partner.partner_management', '合作夥伴管理'), checkPermission: [consts.PARTNER_LIST_VIEW] },
          { to: { name: 'PartnerWorkerList' }, text: displayText('partner.partner_worker_management', '夥伴員工管理'), checkPermission: [consts.PARTNER_WORKER_LIST_VIEW] },
          { to: { name: 'PartnerWorkerListVerifying', query: { status: 'pending', page_type: 'verify' } }, text: this.displayText('partner.partner_worker_verify_page', '夥伴員工審核'), checkPermission: [consts.PARTNER_WORKER_VERIFY_LIST_VIEW] },
          { to: { name: 'PartnerStaffEntry' }, text: this.displayText('partner.partner_staff_list', '夥伴帳號列表'), checkPermission: [consts.PARTNER_STAFF_LIST_VIEW] },]
        },
        {
          key: "sidebar-data-chart",
          text: this.displayText("data_chart.title", "報表中心"),
          icon: 'chart-line-solid.svg',
          order: 350,
          checkPermissionAny: [consts.PARTNER_WORKER_REPORT_LIST, consts.LINE_PUSHED_MESSAGES_LIST_VIEW],
          items: [{ to: { name: 'PartnerWorkerDataChart' }, text: this.displayText('data_chart.partner_worker_chart', '夥伴員工統計'), checkPermission: [consts.PARTNER_WORKER_REPORT_LIST] },
          { to: { name: 'PartnerWorkerJoinLineByMonthDataChart' }, text: displayText('data_chart.partner_worker_join_line_by_month_chart', '夥伴員工綁定統計'), checkPermission: [consts.PARTNER_WORKER_REPORT_LIST] },
          { to: { name: 'StaffByMonthDataChart' }, text: this.displayText('data_chart.staff_join_line_by_month_chart', '業務綁定統計'), checkPermission: [consts.PARTNER_WORKER_REPORT_LIST] },
          { to: { name: 'PushedMessageList' }, text: "LINE 推播紀錄", checkPermission: [consts.LINE_PUSHED_MESSAGES_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-data-center",
          text: "營運資料中心",
          icon: 'file-lines-solid.svg',
          order: 375,
          checkPermissionAny: [
            consts.ORDER_QUERY_EXPORT,
            consts.CUSTOMER_QUERY_EXPORT,
          ],
          items: [
            { to: { name: 'OrderSearchExport' }, text: '訂單資料查詢與匯出', checkPermission: [consts.ORDER_QUERY_EXPORT] },
            { to: { name: 'CustomerSearchExport' }, text: '會員名單查詢與匯出', checkPermission: [consts.CUSTOMER_QUERY_EXPORT] },
          ]
        },
        {
          key: "sidebar-award",
          text: "獎勵應用中心",
          icon: 'trophy-solid.svg',
          order: 400,
          checkPermissionAny: [
            consts.REDEEM_CODE_LIST_VIEW,
            consts.POINT_LIST_VIEW,
            consts.GIFT_LIST_VIEW,
            consts.MODULE_ORDER_TO_POINTS_MODIFY
          ],
          items: [
            { to: { name: 'RedeemCodeBundleList' }, text: '優惠券管理', checkPermission: [consts.REDEEM_CODE_LIST_VIEW] },
            { to: { name: 'PointList' }, text: '點數管理', checkPermission: [consts.POINT_LIST_VIEW] },
            { to: { name: 'GiftList' }, text: '贈品管理', checkPermission: [consts.GIFT_LIST_VIEW] },
            { to: { name: 'ModuleOrderToPointForm' }, text: '訂單點數設定', checkPermission: [consts.MODULE_ORDER_TO_POINTS_MODIFY] },
          ]
        },
        {
          key: "sidebar-marketing",
          text: "行銷應用中心",
          icon: 'crosshairs-solid.svg',
          order: 500,
          checkPermissionAny: [
            consts.SHORT_URL_VIEW,
            consts.REWARD_CARD_LIST_VIEW,
            consts.BENEFIT_CARD_LIST_VIEW,
            consts.BADGE_CAMPAIGN_LIST_VIEW,
            consts.CHECKIN_CAMPAIGN_LIST_VIEW,
            consts.MGM_CAMPAIGN_LIST_VIEW
          ],
          items: [
            { to: { name: 'ShortUrlList' }, text: '短網址管理', checkPermission: [consts.SHORT_URL_VIEW] },
            { to: { name: 'RewardCardList' }, text: '集點卡管理', checkPermission: [consts.REWARD_CARD_LIST_VIEW] },
            { to: { name: 'BenefitCardList' }, text: '權益卡管理', checkPermission: [consts.BENEFIT_CARD_LIST_VIEW] },
            { to: { name: 'BadgeCampaignList' }, text: '徽章活動管理', checkPermission: [consts.BADGE_CAMPAIGN_LIST_VIEW] },
            { to: { name: 'CheckinCampaignList' }, text: '簽到活動管理', checkPermission: [consts.CHECKIN_CAMPAIGN_LIST_VIEW] },
            { to: { name: 'MgmCampaignList' }, text: '邀友入會活動管理', checkPermission: [consts.MGM_CAMPAIGN_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-orders",
          text: "銷售應用中心",
          icon: 'store-solid.svg',
          order: 550,
          checkPermissionAny: [
            consts.ORDER_LIST_VIEW,
            consts.PRODUCT_LIST_VIEW,
            consts.BRANCH_PRODUCT_LIST_VIEW,
            consts.BRANCH_PRODUCT_LIST_VIEW_NO_BRANCH,
            consts.BRANCH_PRODUCT_STOCK_MODIFY,
            consts.BRANCH_PRODUCT_STOCK_MODIFY_NO_BRANCH,
            consts.BRANCH_PRODUCT_STOCK_LIST_VIEW,
            consts.PREORDER_SETTING_LIST,
            consts.PREORDER_LIST_VIEW,
          ],
          items: this.getMarketingCenterItems(),
        },
        {
          key: "sidebar-content",
          text: "內容管理中心",
          icon: 'book-solid.svg',
          order: 600,
          checkPermissionAny: [
            consts.POST_LIST_VIEW,
            consts.FILE_LIST_VIEW,
            consts.FORM_LIST,
            consts.NOTIFICATION_LIST,
            consts.EVENT_LIST_VIEW,
            consts.COLLECTION_LIST,
            consts.CHATROOM_LIST_VIEW,
          ],
          items: [
            { to: { name: 'PostList' }, text: '文章管理', checkPermission: [consts.POST_LIST_VIEW] },
            { to: { name: 'UploadFileList' }, text: '檔案管理', checkPermission: [consts.FILE_LIST_VIEW] },
            { to: { name: 'FormList' }, text: '表單管理', checkPermission: [consts.FORM_LIST] },
            { to: { name: 'NotificationList' }, text: '通知管理', checkPermission: [consts.NOTIFICATION_LIST] },
            { to: { name: 'EventList' }, text: '活動管理', checkPermission: [consts.EVENT_LIST_VIEW] },
            { to: { name: 'CollectionList' }, text: '資料集管理', checkPermission: [consts.COLLECTION_LIST] },
            { to: { name: 'ChatroomList' }, text: '聊天室管理', checkPermission: [consts.CHATROOM_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-bookings",
          text: "登記預約中心",
          icon: 'calendar-solid.svg',
          order: 650,
          checkPermissionAny: [
            consts.BOOKING_PRESET_LIST,
            consts.BOOKING_CALENDAR,
            consts.BOOKING_LIST_VIEW,
            consts.BOOKING_LIST,
          ],
          items: this.getBookingPresetsItems(),
        },
        {
          key: "sidebar-invoice",
          text: "發票模組",
          icon: 'receipt-solid.svg',
          order: 700,
          checkPermissionAny: [
            consts.INVOICE_LIST_VIEW,
            consts.INVOICE_LOG_LIST_VIEW,
            consts.INVOICE_CARRIER_VIEW,
          ],
          items: [
            { to: { name: 'InvoiceList' }, text: '發票列表', checkPermission: [consts.INVOICE_LIST_VIEW] },
            { to: { name: 'InvoiceLogList' }, text: '登錄發票列表', checkPermission: [consts.INVOICE_LOG_LIST_VIEW] },
            { to: { name: 'InvoiceCarrierList' }, text: '載具登錄列表', checkPermission: [consts.INVOICE_CARRIER_VIEW] },
          ]
        },
        {
          key: "sidebar-auto-module",
          text: "自動化模組",
          icon: 'wand-magic-sparkles-solid.svg',
          order: 750,
          checkPermissionAny: [
            consts.MEMBER_EVENT_LIST_VIEW,
            consts.MEMBER_LEVEL_EVENT_LIST_VIEW,
            consts.ACTION_EVENT_LIST_VIEW,
            consts.SHOPPING_EVENT_LIST_VIEW,
            consts.CUSTOMIZE_EVENT_LIST_VIEW,
            consts.MKT_CONFIG_LIST_VIEW],
          items: [
            { to: { name: 'AutoMarketingMemberEvent' }, text: '會員事件設定', checkPermission: [consts.MEMBER_EVENT_LIST_VIEW] },
            { to: { name: 'AutoMarketingMemberLevelEvent' }, text: '會員等級事件設定', checkPermission: [consts.MEMBER_LEVEL_EVENT_LIST_VIEW] },
            { to: '#', text: '活動事件設定', checkPermission: [consts.ACTION_EVENT_LIST_VIEW] },
            { to: '#', text: '購物事件設定', checkPermission: [consts.SHOPPING_EVENT_LIST_VIEW] },
            { to: '#', text: '自定義事件', checkPermission: [consts.CUSTOMIZE_EVENT_LIST_VIEW] },
            { to: { name: 'AutoMarketingList' }, text: '行銷自動化', checkPermission: [consts.MKT_CONFIG_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-partner-point",
          text: "兌換活動列表",
          icon: 'gifts-solid.svg',
          order: 775,
          checkPermissionAny: [consts.PARTNER_MARKETING_EVENT_LIST_VIEW],
          items: [
            { to: { name: 'PartnerMarketingEventList' }, text: '點數/商品兌換活動', checkPermissionAny: [consts.PARTNER_MARKETING_EVENT_LIST_VIEW] },
            { to: { name: 'PartnerMarketingPlanList' }, text: '兌換活動方案', checkPermissionAny: [consts.PARTNER_MARKETING_PLAN_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-control",
          text: "控制中心",
          icon: 'gears-solid.svg',
          order: 800,
          checkPermissionAny: [
            consts.STAFF_LIST_VIEW,
            consts.BRANCH_LIST_VIEW,
            consts.POINT_RULE_VIEW,
            consts.DAILY_ACT_LIST_VIEW,
            consts.MKT_RULE_LIST_VIEW,
          ],
          items: [
            { to: { name: 'StaffList' }, text: '帳號管理', checkPermission: [consts.STAFF_LIST_VIEW] },
            { to: { name: 'Branches' }, text: '分店管理', checkPermission: [consts.BRANCH_LIST_VIEW] },
            { to: { name: 'PointRuleList' }, text: '入點比例管理', checkPermission: [consts.POINT_RULE_VIEW] },
            { to: { name: 'DailyActivityList' }, text: '每日活動管理', checkPermission: [consts.DAILY_ACT_LIST_VIEW] },
            { to: { name: 'MarketingRuleList' }, text: '行銷規則管理', checkPermission: [consts.MKT_RULE_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-poya-groupbuyings",
          text: "分店團購管理",
          icon: 'cart-shopping-solid.svg',
          order: 900,
          checkPermissionAny: [
            consts.GROUPBUYING_LIST_VIEW,
            consts.SELECTION_GROUPBUYING_CREATE,
            consts.STORE_GROUPBUYING_CREATE,
            consts.GROUPBUYING_BLACKLIST,
          ],
          items: [
            { to: { name: 'GroupbuyingsList', query: { tab: 'going' } }, text: '團購列表', checkPermission: [consts.GROUPBUYING_LIST_VIEW] },
            { to: { name: 'StoreGroupbuyingScanProduct' }, text: '門市庫存品開團', checkPermission: [consts.STORE_GROUPBUYING_CREATE] },
            { to: { name: 'GroupbuyingsCreate' }, text: '總公司選品開團', checkPermission: [consts.SELECTION_GROUPBUYING_CREATE] },
            { to: { name: 'BlacklistList', params: { branchID: this.selectedBranch } }, text: '逾期未取名單', checkPermission: [consts.GROUPBUYING_BLACKLIST] },
          ]
        },
        {
          key: "sidebar-poya-groupbuyingsMain",
          text: "總公司團購管理",
          icon: 'cart-shopping-solid.svg',
          order: 910,
          checkPermissionAny: [
            consts.POYA_AUTOAWARD_VIEW,
            consts.MAIN_GROUPBUYING_LIST_VIEW,
            consts.MAIN_STORE_GROUPBUYING_CREATE,
            consts.MAIN_GROUPBUYING_CREATE,
            consts.EVENT_PRODUCT_LIST_VIEW,
            consts.THEME_GROUPBUYING_LIST_VIEW,
            consts.GROUPBUYING_SKU_QTY_UPDATE,
            consts.POYA_GROUPBUYINGORDER_SEARCH,
          ],
          items: [
            { to: { name: 'AutoawardList' }, text: '自動派獎設定', checkPermissionAny: [consts.POYA_AUTOAWARD_VIEW] },
            { to: { name: 'MainGroupbuyingsList', query: { tab: 'going' } }, text: '總公司團購列表', checkPermission: [consts.MAIN_GROUPBUYING_LIST_VIEW] },
            { to: { name: 'MainGroupbuyingScanProduct' }, text: '門市庫存品開團', checkPermission: [consts.MAIN_STORE_GROUPBUYING_CREATE] },
            { to: { name: 'MainGroupbuyingsCreate' }, text: '總公司選品開團', checkPermission: [consts.MAIN_GROUPBUYING_CREATE] },
            { to: { name: 'MainGroupbuyingsBatch' }, text: '下單數量設定', checkPermission: [consts.GROUPBUYING_SKU_QTY_UPDATE] },
            { to: { name: 'ProductWhiteList' }, text: '商品白名單設定', checkPermission: [consts.EVENT_PRODUCT_LIST_VIEW] },
            { to: { name: 'ThemeGroupbuyingList' }, text: '主題團購列表', checkPermission: [consts.THEME_GROUPBUYING_LIST_VIEW] },
            { to: { name: 'PoyaGroupbuyingOrderList' }, text: '顧客訂單查詢', checkPermission: [consts.POYA_GROUPBUYINGORDER_SEARCH] },
          ]
        },
        {
          key: "sidebar-poya-groups",
          text: "群組管理",
          icon: 'users-solid.svg',
          order: 920,
          checkPermissionAny: [
            consts.GROUP_LIST_VIEW_1,
            consts.GROUP_LIST_VIEW_2,
            consts.GROUP_LIST_VIEW_3
          ],
          items: [
            {
              to: { name: 'GroupList' }, text: '群組列表', checkPermissionAny: [consts.GROUP_LIST_VIEW_1,
              consts.GROUP_LIST_VIEW_2,
              consts.GROUP_LIST_VIEW_3]
            },
          ]
        },
        {
          key: "sidebar-poya-group-protect",
          text: "群組保護",
          icon: 'user-shield-solid.svg',
          order: 930,
          checkPermissionAny: [
            consts.GUARD_GROUP_LIST_VIEW,
            consts.GUARD_BLACK_GLOBAL_MODIFY,
            consts.GUARD_GROUP_SETTING_LIST_VIEW,
            consts.GUARD_MEMBER_LIST_VIEW,
            consts.GUARD_REPORT_LIST_VIEW,
            consts.GROUP_MESSAGE_CREATE
          ],
          items: [
            { to: { name: 'GroupProtectMembers' }, text: '成員名單設定', checkPermission: [consts.GUARD_MEMBER_LIST_VIEW] },
            { to: { name: 'GroupProtectBlackMembers' }, text: '廣告黑名單(全店)管理', checkPermission: [consts.GUARD_BLACK_GLOBAL_MODIFY] },
            { to: { name: 'GroupProtectSetting' }, text: '群組保護設定', checkPermission: [consts.GUARD_GROUP_SETTING_LIST_VIEW] },
            { to: { name: 'GuardGroups' }, text: '衛兵群組列表', checkPermission: [consts.GUARD_GROUP_LIST_VIEW] },
            { to: { name: 'GroupProtectGuards' }, text: '衛兵狀態列表', checkPermission: [consts.GUARD_REPORT_LIST_VIEW] },
            { to: { name: 'GroupMessageCreate' }, text: '群組廣播', checkPermission: [consts.GROUP_MESSAGE_CREATE] },
          ]
        },
        {
          key: "sidebar-params-settings",
          text: "參數設定",
          icon: 'sliders-solid.svg',
          order: 940,
          checkPermissionAny: [
            consts.SYSTEM_INFO,
            consts.LINE_QUERY,
            consts.LINE_SETTING_MODIFY,
            consts.LIFF_CARD_SETTING_MODIFY,
            consts.LIFF_UI_SETTING_MODIFY,
            consts.BODYSHOP_SETTING_QUERY,
            consts.CYBERBIZ_SETTING_QUERY,
            consts.CYBERBIZ_SETTING_ORDER_QUERY,
            consts.ELC_SETTING_QUERY,
            orgVariableConfig.twoDfire.permission,
            orgVariableConfig.pospal.permission,
            orgVariableConfig.shopline.permission,
            consts.SHOPLINE_SETTING_QUERY,
            consts.HTY_LMS_SETTING_QUERY,
            consts.HTY_LMS_SETTING_VERIFY_PHONE,
            consts.HTY_LMS_SETTING_CREATE_ACCOUNT,
            consts.HTY_LMS_SETTING_DELETE_ACCOUNT,
            consts.HTY_FLAPS_SETTING_QUERY,
            consts.LUSH_SETTING_QUERY,
          ],
          items: [
            { to: { name: 'LiffPageList' }, text: '系統資訊', checkPermission: [consts.SYSTEM_INFO] },
            { to: { name: 'LineQuery' }, text: 'LINE 查詢', checkPermission: [consts.LINE_QUERY] },
            { to: { name: 'LineSetting' }, text: 'LINE 參數設定', checkPermission: [consts.LINE_SETTING_MODIFY] },
            {
              to: { name: 'OrganizationVariableConfigByCode', params: {organization_variable_id: orgVariableConfig.twoDfire.configKey}},
              text: 'TAKOPOS 設定',
              checkPermission: [orgVariableConfig.twoDfire.permission]
            },
            {
              to: { name: 'OrganizationVariableConfigByCode', params: {organization_variable_id: orgVariableConfig.pospal.configKey}},
              text: '瑞乘POS 設定',
              checkPermission: [orgVariableConfig.pospal.permission]
            },
            {
              to: { name: 'OrganizationVariableConfigByCode', params: {organization_variable_id: orgVariableConfig.shopline.configKey}},
              text: 'SHOPLINE 設定',
              checkPermission: [orgVariableConfig.shopline.permission]
            },
            { to: { name: 'LiffCardSetting' }, text: '會員卡畫面', checkPermission: [consts.LIFF_CARD_SETTING_MODIFY] },
            { to: { name: 'LiffUISetting' }, text: '會員介面設定', checkPermission: [consts.LIFF_UI_SETTING_MODIFY] },
            { to: { name: 'BodyShopForm' }, text: 'BodyShop 查詢', checkPermission: [consts.BODYSHOP_SETTING_QUERY] },
            { to: { name: 'CyberbizForm' }, text: 'CYBERBIZ 會員查詢', checkPermission: [consts.CYBERBIZ_SETTING_QUERY] },
            { to: { name: 'CyberbizOrderSearch' }, text: 'CYBERBIZ 訂單查詢', checkPermission: [consts.CYBERBIZ_SETTING_ORDER_QUERY] },
            { to: { name: 'FlapsAccountQueryForm' }, text: '輔翼會員查詢', checkPermission: [consts.HTY_FLAPS_SETTING_QUERY] },
            { to: { name: 'FlapsCouponQueryForm' }, text: '輔翼優惠券查詢', checkPermission: [consts.HTY_FLAPS_SETTING_QUERY] },
            { to: { name: 'FlapsMemberBonusLogQueryForm' }, text: '輔翼點數紀錄查詢', checkPermission: [consts.HTY_FLAPS_SETTING_QUERY] },
            { to: { name: 'FlapsMemberRemainderBonusQueryForm' }, text: '輔翼可用點數查詢', checkPermission: [consts.HTY_FLAPS_SETTING_QUERY] },
            { to: { name: 'ElcForm' }, text: 'ELC 查詢', checkPermission: [consts.ELC_SETTING_QUERY] },
            { to: { name: 'ShopLineForm' }, text: 'SHOPLINE 查詢', checkPermission: [consts.SHOPLINE_SETTING_QUERY] },
            { to: { name: 'HTYAccountQueryForm' }, text: '新東陽 查詢', checkPermission: [consts.HTY_LMS_SETTING_QUERY] },
            { to: { name: 'HTYVerifyPhoneForm' }, text: '新東陽 手機驗證', checkPermission: [consts.HTY_LMS_SETTING_VERIFY_PHONE] },
            { to: { name: 'HTYCreateAccountForm' }, text: '新東陽 會員新增', checkPermission: [consts.HTY_LMS_SETTING_CREATE_ACCOUNT] },
            { to: { name: 'HTYModifyAccountForm' }, text: '新東陽 會員資料修改', checkPermission: [consts.HTY_LMS_SETTING_CREATE_ACCOUNT] },
            { to: { name: 'HTYModifyLineForm' }, text: '新東陽 LINE 資料修改', checkPermission: [consts.HTY_LMS_SETTING_CREATE_ACCOUNT] },
            { to: { name: 'HTYDeleteAccountForm' }, text: '新東陽 註銷會員', checkPermission: [consts.HTY_LMS_SETTING_DELETE_ACCOUNT] },
            { to: { name: 'LushAccountQueryForm' }, text: 'LUSH 會員查詢', checkPermission: [consts.LUSH_SETTING_QUERY] },
            { to: { name: 'TwoDFireAccountQueryForm' }, text: 'TAKOPOS 查詢', checkPermission: [consts.TWODFIRE_SETTING_QUERY] },
          ]
        },
        {
          key: "sidebar-org-settings",
          text: "組織資料中心",
          icon: 'building-shield-solid.svg',
          order: 950,
          checkPermissionAny: [
            consts.ORGANIZATION_VARIABLE,
            consts.ROLE_LIST_VIEW,
            consts.MODULE_LIST_VIEW,
            consts.KEYWORD_LIST_VIEW,
            consts.SQL_RUNNER_LIST_VIEW,
            consts.MERCHANT_LIST_VIEW,
            consts.LOGS_LIST_VIEW,
            consts.TOKEN_LIST_VIEW,
            consts.SUITE_LIST_VIEW,
          ],
          items: [
            {to: { name: 'OrganizationHome' }, text: '組織管理', checkPermission: [ consts.MERCHANT_LIST_VIEW ]},
            { to: { name: 'OrganizationVariableList' }, text: '參數管理', checkPermission: [consts.ORGANIZATION_VARIABLE] },
            { to: { name: 'ModuleList', params: { orgId: this.organization?.id } }, text: '模組管理', checkPermission: [consts.MODULE_LIST_VIEW] },
            { to: { name: 'RoleList' }, text: '權限管理', checkPermission: [consts.ROLE_LIST_VIEW] },
            { to: { name: 'SuiteList' }, text: '方案管理', checkPermission: [consts.SUITE_LIST_VIEW] },
            { to: { name: 'KeywordList' }, text: '關鍵字管理', checkPermission: [consts.KEYWORD_LIST_VIEW] },
            { to: { name: 'ServerLogList' }, text: '系統紀錄', checkPermission: [consts.LOGS_LIST_VIEW] },
            { to: { name: 'SqlRunnerList' }, text: 'SQL 排程管理', checkPermission: [consts.SQL_RUNNER_LIST_VIEW] },
            { to: { name: 'TokenList' }, text: 'API TOKEN 管理', checkPermission: [consts.TOKEN_LIST_VIEW] },
          ]
        },
        {
          key: "sidebar-system-admin-settings",
          text: "全系統設定",
          icon: 'city-solid.svg',
          order: 999,
          checkPermissionAny: [
            consts.ORGANIZATION_LIST_VIEW,
            consts.ORGANIZATION_SUITE_LIST_VIEW,
            consts.ORGANIZATION_MODULE_LIST_VIEW,
          ],
          items: [
            { to: { name: 'OrganizationList' }, text: '全組織列表', checkPermission: [consts.ORGANIZATION_LIST_VIEW] },
            { to: { name: 'SystemSuiteList' }, text: '系統方案列表', checkPermission: [consts.ORGANIZATION_SUITE_LIST_VIEW] },
            { to: { name: 'OrganizationModuleList' }, text: '全模組列表', checkPermission: [consts.ORGANIZATION_MODULE_LIST_VIEW] },
          ]
        },
      ];
    },

  },
  methods: {
    displayText,
    ...mapActions('general', ['setCurrentBranch', 'setCurrentOrg', 'fetchBranches']),
    async init() {
      if (!this.currentBranch) {
        if (this.myBranches.length) {
          this.selectedBranch = this.myBranches[0].id ?? null;
          this.switchBranch();
        }
      } else {
        this.selectedBranch = this.currentBranch.id;
      }
      if (!this.selectedOrganization) {
        this.selectedOrganization = this.organization.id
      }

      // 如果擁有查看預約管理中心權限，就撈取 bookingPresets
      if (this.checkPermission([consts.BOOKING_LIST_VIEW])) {
        await this.fetchBookingPresets();
      }

      // 如果擁有查看預購單權限，就撈取 preorderSettings
      if (this.checkPermission([consts.PREORDER_LIST_VIEW])) {
        await this.fetchPreorderSettings();
      }
    },

    async switchBranch() {
      let _this = this
      _this.disableSelect = true
      await this.setCurrentBranch(this.selectedBranch).then(() => {
        this.fetchBranches();
        this.$nextTick(() => {
          _this.$router.go(0)
        })
      }).finally(() => {
        _this.disableSelect = false
      })
    },
    async switchOrganization() {
      let _this = this;
      _this.disableSelect = true
      await this.setCurrentOrg(this.selectedOrganization).then(() => {
        this.selectedBranch = (this.currentBranch) ? this.currentBranch.id : null
        _this.$router.replace({ name: 'DashboardHome', params: { org_code: this.organization.code } })
      }).finally(() => {
        _this.disableSelect = false
      })
    },
    updateView() {
      // force router-view update with router key
      this.$emit('updateView')
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker;
      return checker.check(permissions);
    },
    checkPermissionAny(permissions) {
      const checker = new PermissionChecker;
      return checker.checkAny(permissions);
    },
    anyPermissions(permissions) {
      let result = false;
      const checker = new PermissionChecker;
      permissions.forEach(permission => {
        if (checker.check([permission])) {
          result = true;
        }
      });
      return result;
    },
    sidebarOrder(key) {
      return this.dashboardModule.sidebar?.find(x => x.key == key)?.order
    },
    subMenuVisible(i) {
      try {
        return i.items.some((x) => {
          if (x.to.name === this.$route.name) {
            return true;
          }

          if (typeof x.to === 'object' && x.to.name) {
            const resolvedPath = this.$router.resolve({ name: x.to.name, params: x.to.params }).resolved.path;
            return this.$route.path === resolvedPath || this.$route.path.startsWith(resolvedPath + '/');
          }

          return false;
        });
      } catch {
        return false;
      }
    },
    subMenuActive(j) {
      let resolvedRoute = this.$router.resolve({ name: j.to.name, params: j.to.params }).resolved;
      let subMenuPath = resolvedRoute.path;

      // 判斷路徑和參數是否匹配
      let isPathMatching = subMenuPath !== '/' && typeof j.to === 'object' && this.$route.path.startsWith(subMenuPath);
      let areParamsMatching = JSON.stringify(this.$route.params) === JSON.stringify(j.to.params);

      return isPathMatching && areParamsMatching;
    },
    async fetchBookingPresets() {
      const response = await bookingApi.getBookingPresets({
        per_page: BOOKING_COUNT + 1,
        sort_by: 'created_at',
        order_by: 'desc',
        is_valid: true,
      });

      this.bookingPresets = response.data.data;
    },
    getBookingPresetsItems() {
      let items = [
        {
          to: { name: "BookingPresetList", query: { is_valid: true } },
          text: "預約設定檔管理",
          checkPermission: [consts.BOOKING_PRESET_LIST],
        },
        {
          to: { name: "BookingSelectList", query: { is_valid: true } },
          text: "預約管理",
          checkPermissionAny: [consts.BOOKING_LIST],
        },
        { to: { name: 'BookingCenterCalendar' }, text: '預約日曆', checkPermission: [consts.BOOKING_CALENDAR] },
        { to: { name: 'BookingOverview' }, text: '預約總覽', checkPermission: [consts.BOOKING_OVERVIEW] },
      ];

      if (!this.bookingPresets || this.bookingPresets.length === 0) {
        return items;
      }

      this.bookingPresets.slice(0, BOOKING_COUNT).forEach(bookingPreset => {
        items.push({
          to: { name: "BookingCenterBookingList", params: {id: bookingPreset.id} },
          text: bookingPreset.name,
          checkPermission: [consts.BOOKING_LIST_VIEW]
        });
      });

      if (this.bookingPresets.length > BOOKING_COUNT && this.checkPermission([consts.BOOKING_PRESET_LIST])) {
        items.push(
          {
            to: { name: 'BookingPresetList', query: { is_valid: true } },
            text: '(顯示更多)',
            checkPermission: [consts.BOOKING_PRESET_LIST]
          }
        );
      } else if (this.bookingPresets.length > BOOKING_COUNT && this.checkPermission([consts.BOOKING_LIST])) {
        items.push(
          { to: { name: 'BookingSelectList' }, text: '(顯示更多)', checkPermission: [consts.BOOKING_LIST] }
        );
      }

      return items;
    },
    async fetchPreorderSettings() {
      try {
        // 故意多抓一筆，為了 `(顯示更多)` 的功能
        const response = await preorderApi.getPreorderSettings({
          is_enabled: true,
          sort_by: 'end_at',
          per_page: PREORDER_COUNT + 1,
          page: 1,
        });
        this.preorderSettings = response.data.data;
      } catch (e) {
        this.preorderSettings = [];
      }
    },
    getMarketingCenterItems() {
      let items = [
        { to: { name: 'OrderList' }, text: '訂單管理', checkPermission: [consts.ORDER_LIST_VIEW] },
        { to: { name: 'ProductList' }, text: '商品管理', checkPermission: [consts.PRODUCT_LIST_VIEW] },
        {
          to: { name: 'BranchProductList' },
          text: '分店商品列表',
          checkPermissionAny: [consts.BRANCH_PRODUCT_LIST_VIEW, consts.BRANCH_PRODUCT_LIST_VIEW_NO_BRANCH]
        },
        {
          to: { name: 'BranchProductStockList' },
          text: '分店庫存管理',
          checkPermissionAny: [consts.BRANCH_PRODUCT_STOCK_MODIFY, consts.BRANCH_PRODUCT_STOCK_MODIFY_NO_BRANCH]
        },
        { to: { name: 'PreorderSettingList' }, text: '預購單設定檔管理', checkPermission: [consts.PREORDER_SETTING_LIST] },
      ]

      if (!this.preorderSettings || this.preorderSettings.length === 0) {
        return items;
      }

      this.preorderSettings.slice(0, PREORDER_COUNT).forEach(preorderSetting => {
        items.push({
          to: { name: 'PreorderList', params: { id: preorderSetting.id } },
          text: preorderSetting.title,
          checkPermission: [consts.PREORDER_LIST_VIEW]
        })
      });
      if (this.preorderSettings.length > PREORDER_COUNT && this.checkPermission([consts.PREORDER_SETTING_LIST])) {
        items.push({
          to: { name: 'PreorderSettingList' },
          text: '(顯示更多)',
          checkPermission: [consts.PREORDER_SETTING_LIST]
        });
      }
      return items;
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-organization-selector {
  margin-right: 20px;
  margin-left: 20px;
}

// .nav-item .collapse:has(.router-link-exact-active){
//   display: block !important;
// }
</style>
